module.exports = {
    demo: false,
    brand: 'Epoints', // Footer brand
    appName: 'Epoints', // App Name
    showCredits: true, // Show credits in login page
    url: 'https://chat-hub-stag.epoints.vn/', //https://chathub.epoints.vn
}